module.exports = __webpack_public_path__ + "static/img/about1back.88e3d5c9.jpg";